import React from 'react';
import { FeatureTitle, PopulerDestination, Row, Container } from '../../../components';

const Explore = ({ data = [], title = 'no title', description = 'no description' }) => {
  return (
    <Container>
      <FeatureTitle title={title} description={description} />
      <Row between>
        {data.map((item, index) => (
          <PopulerDestination key={index} img={item.img} title={item.title} description={item.description} />
        ))}
      </Row>
    </Container>
  );
};

export default Explore;
